// DS: PO20
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import Modal, { MODAL_FOOTER_BUTTON_SIZE, MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import Sidebar from '../_partials/Sidebar';
import { MediaSourceType, MediaPopupMode } from '../types';
import { DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_MANAGER, MAX_SELECTED_ITEMS } from '../constants';
import MediaSourceMenu from '../_partials/MediaSourceMenu';
import GallectionManager from '../Gallections/GallectionManager';
import GallectionContentManager from '../Gallections/GallectionContentManager';
import CustomSetDeviationManager from '../Deviations/DeviationManager/CustomSetDeviationManager';
import withOwnReduxStore from '../_hocs/withOwnReduxStore';
import withCurrentMediaSource from '../_hocs/withCurrentMediaSource';
import withCurrentGallection from '../_hocs/withCurrentGallection';
import withMediaPopupInit from '../_hocs/withMediaPopupInit';
import withCustomSetDeviations from '../_hocs/withCustomSetDeviations';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import withCurrentTier from '../_hocs/withCurrentTier';
import ModalsForMM from '../_partials/ModalsForMM';
import NotificationsForMM from '../_partials/NotificationsForMM/NotificationsForMM';
import TierDeviationManager from '../Deviations/DeviationManager/TierDeviationManager';
import TierExplorer from '../Tiers/TierExplorer';
import DndProviderWrapper from '../../Dnd/DndProviderWrapper';
import mediaPopupStyles from '../MediaPopup.scss';
const enhance = compose(withOwnReduxStore, withCurrentMediaSource, withMediaPopupInit, withCurrentGallection, withCurrentTier, withCustomSetDeviations, withMobileContext, withTranslation());
var _React_Component;
class MediaManager extends (_React_Component = React.Component) {
    componentDidMount() {
        const { initialMediaSource, initialDeviationSet, initMediaPopup, gallectionFolder, tier, allowedDeviationTypes, mediaSourceTypes, withMediaSourceSelector, withNewGallectionPopupOpen = false, withAddDeviationsPopupOpen = false, allowUploads = true, gruser } = this.props;
        const selectionLimit = MAX_SELECTED_ITEMS;
        let mediaSource = initialMediaSource;
        if (initialDeviationSet) {
            mediaSource = MediaSourceType.CUSTOM_SET;
        }
        initMediaPopup({
            mode: MediaPopupMode.MANAGER,
            mediaSource,
            initialDeviationSet,
            selectionLimit,
            gallectionFolder,
            tier,
            allowedDeviationTypes,
            mediaSourceTypes,
            withMediaSourceSelector,
            withNewGallectionPopupOpen: withNewGallectionPopupOpen,
            withAddDeviationsPopupOpen,
            allowUploads,
            gruser
        });
    }
    render() {
        const { onClose, withMediaSourceSelector, t, isMobile } = this.props;
        if (isMobile) {
            // MediaManager is not supported on mobile
            // only MediaSelector
            return null;
        }
        return /*#__PURE__*/ React.createElement(DndProviderWrapper, null, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                sectionname: 'media-manager'
            }
        }, /*#__PURE__*/ React.createElement(Modal, {
            isOpen: true,
            className: mediaPopupStyles['root'],
            contentClassName: mediaPopupStyles['content'],
            heading: this.getTitle(),
            showHeaderBorder: true,
            showFooterBorder: true,
            onRequestClose: ()=>onClose(),
            footerRight: [
                /*#__PURE__*/ React.createElement(BrandedButton, {
                    key: "done",
                    variant: "brand-green",
                    size: MODAL_FOOTER_BUTTON_SIZE,
                    style: {
                        minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH
                    },
                    onClick: this.onDone
                }, t('mediapopup.done'))
            ]
        }, withMediaSourceSelector && /*#__PURE__*/ React.createElement(Sidebar, null, /*#__PURE__*/ React.createElement(MediaSourceMenu, {
            mediaSourceTypes: [
                MediaSourceType.GALLERY,
                MediaSourceType.COLLECTION
            ]
        })), this.renderContentArea(), /*#__PURE__*/ React.createElement(NotificationsForMM, null)), /*#__PURE__*/ React.createElement(ModalsForMM, null)));
    }
    renderContentArea() {
        const { initialDeviationSet, currentMediaSource, currentGallection, currentTier } = this.props;
        if (initialDeviationSet) {
            return /*#__PURE__*/ React.createElement(CustomSetDeviationManager, null);
        }
        if (currentMediaSource && [
            MediaSourceType.TIER_DEVIATIONS,
            MediaSourceType.TIER_POSTS
        ].includes(currentMediaSource)) {
            if (currentTier) {
                return /*#__PURE__*/ React.createElement(TierDeviationManager, null);
            }
            return /*#__PURE__*/ React.createElement(TierExplorer, null);
        }
        if (!currentGallection) {
            return /*#__PURE__*/ React.createElement(GallectionManager, null);
        }
        return /*#__PURE__*/ React.createElement(GallectionContentManager, null);
    }
    getTitle() {
        const { currentMediaSource, t, title } = this.props;
        if (title) {
            return title;
        }
        switch(currentMediaSource){
            case MediaSourceType.GALLERY:
                return t('mediapopup.editYourGalleries');
            case MediaSourceType.COLLECTION:
                return t('mediapopup.editYourCollections');
            case MediaSourceType.PRIVATE_COLLECTION:
                return t('mediapopup.editYourPrivateCollections');
            case MediaSourceType.CUSTOM_SET:
                return t('mediapopup.editYourGallery');
            case MediaSourceType.STASH:
                return t('mediapopup.editYourStash');
            default:
                return t('mediapopup.title');
        }
    }
    constructor(...args){
        super(...args), _define_property(this, "onDone", ()=>{
            const { deviations, currentMediaSource } = this.props;
            if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
                this.props.onDone(deviations);
            } else {
                this.props.onDone();
            }
        });
    }
}
_define_property(MediaManager, "defaultProps", {
    initialMediaSource: MediaSourceType.GALLERY,
    withMediaSourceSelector: false,
    mediaSourceTypes: DEFAULT_MEDIASOURCE_TYPES_FOR_MEDIA_MANAGER,
    withNewGallectionPopupOpen: false,
    withAddDeviationsPopupOpen: false
});
export default enhance(MediaManager);

//# sourceMappingURL=MediaManager.js.map